import { Box, Spinner } from '@factorialco/deprecated-design-system'

export const Loading = () => {
  return (
    <Box justifyContent="center" alignItems="center" height="full">
      <Spinner />
    </Box>
  )
}
